import React, { Component } from 'react';
import { inject, observer, Provider } from 'mobx-react';
import { autorun } from 'mobx';
import { FloorAreaStore } from './floorarea.store';
import { FloorAreaComponent } from './floorarea.component';
import FloorAreaForm from './floorarea.form';

@inject('appStore', 'routerStore', 'gettingStartedStore')
@observer
export class FloorAreaProvider extends Component {
    store;

    disabledRun;

    constructor(props) {
        super(props);
        const { appStore, routerStore, match, gettingStartedStore } = props,
            { history } = routerStore;

        appStore.setURLProps(match);
        appStore.clearError();

        this.store = new FloorAreaStore({
            appStore
        });

        this.form = new FloorAreaForm({
            store: this.store,
            appStore: appStore
        });

        this.disposeForm = autorun(() => {
            if (
                !appStore.loading &&
                appStore.userData &&
                appStore.userData.floorarea
            ) {
                appStore.hydrateFormFields(
                    appStore.userData.floorarea,
                    false,
                    this.form
                );
            }

            if (
                !this.disabledRun &&
                gettingStartedStore.switchReadOnly()
            ) {
                this.form.disableFieldEditing();
                this.store.setIsReadOnly(true);
                this.disabledRun = true;
            }

            if (this.store.goNext) {
                this.store.goNext = false;
                history.push({ pathname: '/livingroom/1/walls', state: { transition: 'forward' } });
            }
        });
    }

    componentWillUnmount() {
        this.disposeForm();
    }

    render() {
        return (
            <Provider form={this.form} store={this.store}>
                <FloorAreaComponent key='floorarea' />
            </Provider>
        );
    }
}
